// extracted by mini-css-extract-plugin
module.exports = {"past-event":"EventCard-134bc3a0-scss"};